import styles from "./header.module.css";

export default function CabinetPic() {
	return (
		<div className={styles.cabinet_pic}></div>
	)
}
